import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService, UrlParam } from './classes/BaseService';

@Injectable({
  providedIn: 'root'
})
export class ShopService extends BaseService{

  apiUrl = "Shop.php?";

  constructor(protected http: HttpClient) {
    super(http);
  }

  getProducts(sessionToken: string, country: string, productCountry: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("productCountry", productCountry),
      new UrlParam("action", "getProducts"),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.get(url);
  }

  redeemProduct(id: string, sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "redeemProduct"),
      new UrlParam("id", id),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  approvePurchase(id: string, sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "approvePurchase"),
      new UrlParam("id", id),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.post(url, params);
  }

  getUserTransactions(sessionToken: string, country: string) {
    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("action", "getUserTransactions"),
      new UrlParam("sessionToken", sessionToken)
    );
    return this.get(url);
  }

  addProduct(sessionToken: string, country: string, productCountry: string, productType: string,
    value: string, costsInPoints: string, currency: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("action", "addProduct"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("productCountry", productCountry),
      new UrlParam("productType", productType),
      new UrlParam("value", value),
      new UrlParam("costsInPoints", costsInPoints),
      new UrlParam("currency", currency)
    );
    return this.post(url, params);
  }

  addCardCodeToProduct(sessionToken: string, country: string, id: string, cardCode: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("action", "addCardCodeToProduct"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("id", id),
      new UrlParam("cardCode", cardCode)
    );
    return this.post(url, params);
  }

  resendCode(sessionToken: string, country: string, id: string) {
    const url = this.serverUrl + this.apiUrl;
    const params = this.buildUrlParams(
      new UrlParam("action", "resendCode"),
      new UrlParam("sessionToken", sessionToken),
      new UrlParam("country", country),
      new UrlParam("id", id)
    );
    return this.post(url, params);
  }
  
}
